import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AuthPage from '@/pages/auth/page';
import MatchingPage from '@/pages/matching/page';
import VideoChatPage from '@/pages/video-chat/page';
import PremiumPage from '@/pages/premium/page';
import SettingsPage from '@/pages/settings/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/auth', element: <AuthPage /> },
  { path: '/matching', element: <MatchingPage /> },
  { path: '/chat', element: <VideoChatPage /> },
  { path: '/premium', element: <PremiumPage /> },
  { path: '/settings', element: <SettingsPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
